import React from 'react';

import { ProductWizardStep } from 'features/menu/components/product-wizard/types';
import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

export const FADE_IN_ANIMATION_MILLIS = 700;
export const SLIDE_IN_ANIMATION_MILLIS = 300;

export const SelectorContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.fullWidth, style]} />
);

export const productDetailFlowContainerStyles: any = {
  flex: 1,
  width: '100%',
};

export const ProductDetailFlowContent = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productDetailFlowContent, style]} />
);

export const getBackgroundColorByStep = (step: ProductWizardStep) =>
  step === ProductWizardStep.ProductHome || step === ProductWizardStep.PickerReview
    ? primitive.$mayoEggWhite
    : primitive.$white;

const styles = StyleSheet.create({
  fullWidth: {
    width: '100%',
  },
  productDetailFlowContent: {
    flex: 1,
    width: '100%',
  },
});
